import api from './api';

export async function getMenuProducts() {
  const { data } = await api.get('/menu-product');
  return data;
}

export async function createMenuProduct(payload) {
  const { data } = await api.post('/menu-product', payload);
  return data;
}

export async function updateMenuProduct(id, payload) {
  const { data } = await api.put(`/menu-product/${id}`, payload);
  return data;
}

export async function deleteMenuProduct(id) {
  const { data } = await api.delete(`/menu-product/${id}`);
  return data;
}
